import moment from "moment"
import React, { Component } from "react"
import DatePicker from "react-datepicker"
// import "react-datepicker/dist/react-datepicker.css"
import styled, { css } from "react-emotion"

const FixedCss = styled("span")`
    .react-datepicker__time-container
        .react-datepicker__time
        .react-datepicker__time-box
        ul.react-datepicker__time-list {
        padding: 0;
    }
    ${props =>
        props.bugfixdatetime
            ? css`
                  .react-datepicker {
                      min-width: 312px;
                  }
              `
            : null};
`

class Datepicker extends Component {
    render() {
        let selected = this.props.selected

        if (selected && typeof selected === "string") {
            selected = moment(selected)
        }

        return (
            <FixedCss
                bugfixdatetime={this.props.showTimeSelect}
                children={<DatePicker {...this.props} selected={selected} />}
            />
        )
    }
}

Datepicker.propTypes = DatePicker.propTypes

export default Datepicker



// WEBPACK FOOTER //
// ./src/ui/legacy/DatePicker.js